import { Component, OnInit, Input, Output, EventEmitter, ElementRef, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccordionComponent implements OnInit, AfterViewInit {
  constructor(
    private _el: ElementRef<HTMLElement>,
    private _route: ActivatedRoute
  ) {}

  @Input() header: string;
  @Input() helpText: string;
  @Input() indicator: boolean;
  @Input() counter: number;
  @Input() startExpanded: boolean = false;
  @Input() fragment?: string;
  @Output() stateChanged = new EventEmitter<boolean>();

  collapse: boolean = true;

  ngOnInit() {
    this.collapse = !this.startExpanded;
  }

  ngAfterViewInit(): void {
    // Auto-expand and scroll into view if URL fragment matches provided input
    this._route.fragment.subscribe(fragment => {
      if (this.fragment && fragment === this.fragment) {
        if (this.collapse) {
          this.collapse = false;
          this.stateChanged.emit(true);
        }
        setTimeout(() => {
          try {
            this._el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch {}
        }, 0);
      }
    });
  }

  onclick() {
    this.collapse = !this.collapse;
    this.stateChanged.emit(!this.collapse);
  }
}
